import {
  AccountMenu as AccountMenuMoly,
  AccountMenuProps,
} from '@bfe/account-menu';

const AccountMenu = (props: AccountMenuProps) => {
  return <AccountMenuMoly {...props} />;
};
export default AccountMenu;
